(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 6057:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5169);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7379);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2317);
/* harmony import */ var images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3017);
/* harmony import */ var images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_3__);





function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  bottom: 0;\n  display: flex;\n  overflow: hidden;\n  width: 100%;\n  max-width: 350px;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0 0 0.8rem;\n  background: ",
        ";\n  .exclamationPoint {\n    position: absolute;\n    left: 10px;\n    width: 100%;\n    max-width: 19px;\n    height: 18px;\n    padding: 0;\n    margin: 0;\n    background: url(",
        ") no-repeat;\n  }\n  .messageText {\n    color: ",
        ";\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ErrorBanner = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledErrorBanner, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "exclamationPoint"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "messageText",
                children: "Invalid activation code. Please try again."
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorBanner);
var StyledErrorBanner = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-8551c630-0"
})(_templateObject(), styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Monza */ .Z.Monza, (images_global_alert_white_svg__WEBPACK_IMPORTED_MODULE_3___default()), styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].white */ .Z.white);


/***/ }),

/***/ 5714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_RegCodeInput; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(2317);
// EXTERNAL MODULE: ./styles/animations.ts
var animations = __webpack_require__(3167);
// EXTERNAL MODULE: ./styles/helper.ts + 1 modules
var helper = __webpack_require__(9900);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(4231);
;// CONCATENATED MODULE: ./validations/schemas/RegCodeSchema.ts

// eslint-disable-next-line @typescript-eslint/no-var-requires
var yupResolver = (__webpack_require__(5496)/* .yupResolver */ .X);
var RegCodeSchema = function() {
    return yupResolver(es/* object */.Ry().shape({
        regCode: es/* string */.Z_().nullable().required('Reg code is required').min(4, 'Min length is 4 characters')
    }).required());
};
/* harmony default export */ var schemas_RegCodeSchema = (RegCodeSchema);

// EXTERNAL MODULE: ./context/GlobalContextProvider.tsx
var GlobalContextProvider = __webpack_require__(1387);
// EXTERNAL MODULE: ./components/common/index.tsx + 5 modules
var common = __webpack_require__(8761);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./context/state/reducer.ts + 1 modules
var reducer = __webpack_require__(2807);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var utils_helper = __webpack_require__(9981);
// EXTERNAL MODULE: ./lib/analytics/trackCalls.ts + 4 modules
var trackCalls = __webpack_require__(2896);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 6 modules
var hooks = __webpack_require__(8113);
// EXTERNAL MODULE: ./lib/hooks/useFlowManager.ts
var useFlowManager = __webpack_require__(9697);
;// CONCATENATED MODULE: ./components/RegCodeInput/hooks.ts










function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var useRegCodeInput = function(param) {
    var profile = param.profile, setRegCodeError = param.setRegCodeError;
    var ref = (0,react.useContext)(GlobalContextProvider/* AppContext */.I), dispatch = ref.dispatch, secondScreenVersion = ref.state.secondScreenVersion;
    var ref1 = (0,react.useState)(''), regCode1 = ref1[0], setRegCode = ref1[1];
    var ref2 = (0,hooks/* useBoolean */.kt)(false), error = ref2.value, setErrorTrue = ref2.setTrue, setErrorFalse = ref2.setFalse;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,useFlowManager/* default */.Z)(), cookies = ref3.cookies, setCookie = ref3.setCookie, removeCookie = ref3.removeCookie;
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(regCode) {
            var response, firstScreenDeviceId, firstScreenVersion, isMvpd, isRegister, account, info, info1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setErrorFalse();
                        setRegCodeError(false);
                        removeCookie(constants/* COOKIE_CODE_INFO */.r5);
                        ;
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return profile.validateRegCode({
                            regCode: regCode
                        });
                    case 7:
                        response = _ctx.sent;
                        firstScreenDeviceId = response.firstScreenDeviceId, firstScreenVersion = response.firstScreenVersion, isMvpd = response.isMvpd, isRegister = response.isRegister;
                        _ctx.next = 11;
                        return profile.loginAnonymously({
                            deviceId: firstScreenDeviceId
                        });
                    case 11:
                        account = _ctx.sent;
                        if (!firstScreenVersion) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 15;
                        return profile.setRegCodeStatus({
                            regCode: regCode,
                            firstScreenVersion: firstScreenVersion,
                            secondScreenVersion: secondScreenVersion,
                            additionalHeaders: {
                                authorization: 'Bearer ' + account.accessToken
                            }
                        });
                    case 15:
                        dispatch((0,reducer/* setFirstScreenVersion */.qs)(firstScreenVersion));
                    case 16:
                        info = _objectSpread({
                            code: regCode,
                            deviceId: (0,utils_helper.uuidv4)(),
                            type: constants/* CODE_TYPE_API */.Mp
                        }, response, {
                            secondScreenVersion: secondScreenVersion
                        });
                        setRegCode(regCode);
                        (0,trackCalls/* handleTrackEvent */.GV)({
                            eventName: trackCalls/* Events.PROFILE_INITIATED */.zW.PROFILE_INITIATED,
                            props: {
                                page_activation_code: regCode
                            }
                        });
                        setCookie(constants/* COOKIE_CODE_INFO */.r5, info, {
                            path: constants/* ROUTE_HOME */.XX
                        });
                        dispatch((0,reducer/* setCodeInfo */.ys)(cookies[constants/* COOKIE_CODE_INFO */.r5]));
                        // Now & Sports flow
                        if (isRegister) dispatch((0,reducer/* setIsRegister */.ko)(isRegister));
                        if (!isMvpd) {
                            _ctx.next = 30;
                            break;
                        }
                        // set Anonymous Account Cookie
                        (0,utils_helper.setAccountCookie)(account);
                        dispatch((0,reducer/* setFlowStage */.Kc)(constants/* FLOW_STAGE_MVPD_SELECT */.Vr));
                        (0,trackCalls/* handleTrackEvent */.GV)({
                            eventName: trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED,
                            props: {
                                page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                                page_destination_url: window.location.origin + constants/* ROUTE_MVPD */.W3
                            }
                        });
                        _ctx.next = 28;
                        return router.push(constants/* ROUTE_MVPD */.W3);
                    case 28:
                        _ctx.next = 35;
                        break;
                    case 30:
                        dispatch((0,reducer/* setFlowStage */.Kc)(constants/* FLOW_STAGE_PROFILE_AUTH */.T7));
                        // remove Anonymous Account Cookie to go get a Profile Account cookie
                        removeCookie(constants/* ACCOUNT_COOKIE_NAME_FOX */.EO);
                        (0,trackCalls/* handleTrackEvent */.GV)({
                            eventName: trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED,
                            props: {
                                page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                                page_destination_url: window.location.origin
                            }
                        }, {
                            eventName: trackCalls/* Events.SUBMIT_CODE_COMPLETED */.zW.SUBMIT_CODE_COMPLETED,
                            props: {
                                page_active_code: regCode
                            }
                        });
                        _ctx.next = 35;
                        return router.push(constants/* ROUTE_ACCOUNT */.I);
                    case 35:
                        _ctx.next = 46;
                        break;
                    case 37:
                        _ctx.prev = 37;
                        _ctx.t0 = _ctx["catch"](4);
                        dispatch((0,reducer/* setError */.sT)(_ctx.t0));
                        dispatch((0,reducer/* setIsRegister */.ko)(false));
                        info1 = _objectSpread({
                            code: regCode
                        }, response);
                        setCookie(constants/* COOKIE_CODE_INFO */.r5, info1, {
                            path: constants/* ROUTE_HOME */.XX
                        });
                        setRegCodeError(true);
                        setErrorTrue();
                        (0,trackCalls/* handleTrackEvent */.GV)({
                            eventName: trackCalls/* Events.BUTTON_LINK_SELECTED */.zW.BUTTON_LINK_SELECTED,
                            props: {
                                page_item_title: trackCalls/* Events.SUBMIT */.zW.SUBMIT,
                                page_destination_url: window.location.origin
                            }
                        }, {
                            eventName: trackCalls/* Events.PROFILE_ACCESS_ACTIVATION_ERROR */.zW.PROFILE_ACCESS_ACTIVATION_ERROR,
                            props: {
                                page_activation_code: regCode,
                                page_error_description: 'no error description',
                                page_error_type: 'invalid form input'
                            }
                        });
                    case 46:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    37
                ]
            ]);
        }));
        return function handleSubmit(regCode) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        regCode: regCode1,
        setRegCode: setRegCode,
        handleSubmit: handleSubmit,
        error: error
    };
};
/* harmony default export */ var RegCodeInput_hooks = (useRegCodeInput);

;// CONCATENATED MODULE: ./components/RegCodeInput/index.tsx













function RegCodeInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RegCodeInput_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RegCodeInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RegCodeInput_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function RegCodeInput_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RegCodeInput_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RegCodeInput_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      width: 200px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  input {\n    text-transform: uppercase;\n    padding: 0;\n    ",
        "\n    &:focus,\n    :active {\n      border: solid 2px ",
        ";\n    }\n    &::placeholder {\n      color: ",
        ";\n      text-transform: initial;\n      opacity: 0.5;\n    }\n    &.error {\n      border: solid 2px ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var RegCodeInput = function(param) {
    var profile = param.profile, setRegCodeError = param.setRegCodeError;
    var ref5 = (0,react.useContext)(GlobalContextProvider/* AppContext */.I), error = ref5.state.error;
    var ref1 = RegCodeInput_hooks({
        profile: profile,
        setRegCodeError: setRegCodeError
    }), handleSubmitRegCode = ref1.handleSubmit;
    var ref2 = (0,react.useState)(), qrCode = ref2[0], setQrCode = ref2[1];
    var ref3 = (0,react.useState)(false), isQrCode = ref3[0], setIsQrCode = ref3[1];
    (0,react.useEffect)(function() {
        var ref;
        if (location === null || location === void 0 ? void 0 : (ref = location.pathname) === null || ref === void 0 ? void 0 : ref.startsWith(constants/* PATH_ACTIVATE */.rr)) {
            var arr = location === null || location === void 0 ? void 0 : location.href.split('/').filter(function(str) {
                return str;
            });
            var code = arr[(arr === null || arr === void 0 ? void 0 : arr.indexOf('activate')) + 1];
            setQrCode(code);
            if (code) setIsQrCode(true);
        }
    }, []);
    var ref4 = (0,index_esm/* useForm */.cI)({
        mode: 'onChange',
        reValidateMode: 'onSubmit',
        resolver: schemas_RegCodeSchema()
    }), register = ref4.register, handleSubmit = ref4.handleSubmit, isValid = ref4.formState.isValid;
    var onSubmit = function() {
        var _ref = RegCodeInput_asyncToGenerator(runtime_default().mark(function _callee(data) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return handleSubmitRegCode(data.regCode.toUpperCase());
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var disable = function() {
        if (isQrCode) {
            return false;
        }
        return !isValid;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Input */.II, RegCodeInput_objectSpread({}, register('regCode', {
                    required: true
                }), {
                    placeholder: "Activation Code",
                    autoCapitalize: "on",
                    type: "text",
                    autoFocus: true,
                    className: error ? 'error' : '',
                    defaultValue: qrCode
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Button */.zx, {
                    kind: "default",
                    type: "submit",
                    disabled: disable(),
                    children: "Submit"
                })
            ]
        })
    }));
};
/* harmony default export */ var components_RegCodeInput = (RegCodeInput);
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-40449d33-0"
})(_templateObject1(), animations/* fadein */.jF, helper/* respondTo.bp_768 */.s.bp_768(_templateObject()), colors/* default.azureRadiance */.Z.azureRadiance, colors/* default.white */.Z.white, colors/* default.error */.Z.error);


/***/ }),

/***/ 5169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7379);
/* harmony import */ var lib_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8113);
/* harmony import */ var lib_utils_configs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2670);
/* harmony import */ var lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2896);
/* harmony import */ var context_state_reducer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2807);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1387);
/* harmony import */ var components_RegCodeInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5714);
/* harmony import */ var components_ErrorBanner__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3308);
/* harmony import */ var components_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8761);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1407);













function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 180px;\n  padding: 0;\n  margin: 0 auto 2rem;\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: -0.5px;\n  line-height: 1.3em;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var IndexPage = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), regCodeError = ref[0], setRegCodeError = ref[1];
    var dispatch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_7__/* .AppContext */ .I).dispatch;
    var profile = (0,lib_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useGetProfileSdk */ .Iw)(lib_utils_configs__WEBPACK_IMPORTED_MODULE_4__/* .profileConfig */ .Vc);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_6__/* .setLoading */ .K4)(false));
        dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_6__/* .setError */ .sT)(''));
        dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_6__/* .setFlowStage */ .Kc)(_constants__WEBPACK_IMPORTED_MODULE_11__/* .FLOW_STAGE_ENTER_REG_CODE */ .h3));
        router.prefetch(_constants__WEBPACK_IMPORTED_MODULE_11__/* .ROUTE_MVPD */ .W3);
        router.prefetch(_constants__WEBPACK_IMPORTED_MODULE_11__/* .ROUTE_ACCOUNT */ .I);
    }, [
        dispatch,
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_5__/* .mountDataLayer */ .jV)();
        (0,lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_5__/* .setPageAnalyticsData */ .l9)({
            pageName: lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_5__/* .PageNames.SUBMIT_CODE_LANDING */ .sn.SUBMIT_CODE_LANDING,
            pageType: lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_5__/* .PageTypes.ACTIVATION_CODE */ .c7.ACTIVATION_CODE
        });
        (0,lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_5__/* .handleHomePageEvent */ .qH)();
        return function() {
            return (0,lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_5__/* .setPageAnalyticsData */ .l9)({
                pageName: '',
                pageType: ''
            });
        };
    }, []);
    if (!profile) return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common__WEBPACK_IMPORTED_MODULE_10__/* .Loader */ .aN, {
        abCenter: true
    }));
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common__WEBPACK_IMPORTED_MODULE_10__/* .SEO */ .HJ, {
                title: "Home"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Home, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(H2, {
                        children: [
                            "Enter the code ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "displayed on your TV screen."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RegCodeInput__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        profile: profile,
                        setRegCodeError: setRegCodeError
                    })
                ]
            }),
            regCodeError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ErrorBanner__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common__WEBPACK_IMPORTED_MODULE_10__/* .Footer */ .$_, {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);
var Home = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-f1bb77a6-0"
})(_templateObject());
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-f1bb77a6-1"
})(_templateObject1());


/***/ }),

/***/ 3017:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTggMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvRG93bmxvYWRzL0FjdGlvbnMvRG93bmxvYWQgRXJyb3IvMTg8L3RpdGxlPgogICAgPGcgaWQ9Ikljb25zL0Rvd25sb2Fkcy9BY3Rpb25zL0Rvd25sb2FkLUVycm9yLzE4IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNOSwwIEMxMy45NzA1NjI3LDAgMTgsNC4wMjk0MzcyNSAxOCw5IEMxOCwxMy45NzA1NjI3IDEzLjk3MDU2MjcsMTggOSwxOCBDNC4wMjk0MzcyNSwxOCAwLDEzLjk3MDU2MjcgMCw5IEMwLDQuMDI5NDM3MjUgNC4wMjk0MzcyNSwwIDksMCBaIE05LDEuMjUgQzQuNzE5NzkzMTksMS4yNSAxLjI1LDQuNzE5NzkzMTkgMS4yNSw5IEMxLjI1LDEzLjI4MDIwNjggNC43MTk3OTMxOSwxNi43NSA5LDE2Ljc1IEMxMy4yODAyMDY4LDE2Ljc1IDE2Ljc1LDEzLjI4MDIwNjggMTYuNzUsOSBDMTYuNzUsNC43MTk3OTMxOSAxMy4yODAyMDY4LDEuMjUgOSwxLjI1IFogTTEwLDEyIEwxMCwxNCBMOCwxNCBMOCwxMiBMMTAsMTIgWiBNMTAsNCBMMTAsMTEgTDgsMTEgTDgsNCBMMTAsNCBaIiBpZD0iRXJyb3IiIGZpbGw9IiNmZmZmZmYiPjwvcGF0aD4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [130,726,782,896,774,888,179], function() { return __webpack_exec__(6057); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);